/**
 * #340 (10-10): an open task's due line, in the Tasks page's words ("24d overdue" in red,
 * "Due today", "Due tomorrow", else the date), for the Dashboard's Tasks card.
 */
const dayFloor = (v: string | Date) => {
  const x = new Date(v);
  x.setHours(0, 0, 0, 0);
  return x.getTime();
};
const shortDay = (v: string) =>
  new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

export function taskDueLine(
  due: string | null,
  now: Date = new Date(),
): { text: string; late: boolean } {
  if (!due) return { text: 'No due date', late: false };
  const diff = Math.round((dayFloor(due) - dayFloor(now)) / 86400_000);
  if (diff < 0) return { text: `${-diff}d overdue · Due ${shortDay(due)}`, late: true };
  if (diff === 0) return { text: 'Due today', late: false };
  if (diff === 1) return { text: 'Due tomorrow', late: false };
  return { text: `Due ${shortDay(due)}`, late: false };
}
